const toggleShowClickedEvent = function(event) {
  event.preventDefault();
  event.target.closest('toggle-items-visibility').toggleShowClicked();
}

class ToggleItemsVisibility extends HTMLElement {
  connectedCallback() {
    if(!this.isConnected) {
      return;
    }

    this.toggleShowLink.addEventListener("click", toggleShowClickedEvent);
  }

  get toggleShowLink() {
    return this.querySelector("[data-items-toggle-link]");
  }

  get containerTarget() {
    return document.querySelector(`${this.dataset.containerTarget}`);
  }

  toggleShowClicked() {
    this.containerTarget.querySelectorAll(".hidden").forEach(element => {
      element.classList.remove("hidden");
    });

    this.toggleShowLink.remove();
  }

}

if (!window.customElements.get("toggle-items-visibility")) {
  window.customElements.define("toggle-items-visibility", ToggleItemsVisibility);
}
